import { BackendError, Service } from '@genial/services';
import {
  ResponsesDirectTreasuryItemResponse,
  ResponsesStatementDetailsDirectTreasuryResponse,
} from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../../master/selector';
import { screenName } from '../../constants';

export const directTreasuryStatementsQuery = selectorFamily<
  | {
      data: ResponsesDirectTreasuryItemResponse;
    }
  | null
  | undefined,
  { accountNumber: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/directTreasuryStatementsQuery',
  get: ({ accountNumber, callEndpoint }) => {
    return async ({ get }) => {
      const responseEmpty = { data: {} as ResponsesDirectTreasuryItemResponse };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByDirectTreasuryAccountNumber({
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
          accountNumber,
        });

        const response = {
          data: data?.directTreasury || responseEmpty.data,
        };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});

export const directTreasuryStatementsDetailsQuery = selectorFamily<
  | {
      data: ResponsesStatementDetailsDirectTreasuryResponse[];
    }
  | null
  | undefined,
  { accountNumber: number; titleId: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/directTreasuryStatementsDetailsQuery',
  get: ({ accountNumber, callEndpoint, titleId }) => {
    return async ({ get }) => {
      const responseEmpty = { data: [] as ResponsesStatementDetailsDirectTreasuryResponse[] };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const advisorSelected = get(advisorIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByDirectTreasuryDetailsAccountNumber({
          advisorId: advisorSelected,
          screenName,
          accountNumber,
          titleId,
        });

        const response = { data: data || responseEmpty.data };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});
